import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {AbstractControl, FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {ProfileInfo} from "@biletix/core/models/event/profile-info.model";
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {CustomValidators} from "@biletix/core/common/validators/custom-validators";
import {Validation} from "@biletix/core/models/event/validation.model";
import {ValidationFieldConfig} from "@biletix/core/models/event/validation-field-config.model"; 

export interface ProfileValidationConfig {
    profile: ProfileInfo;
    validationImage: string;
    group: FormGroup;
}

/**
 * @author otunctan
 */
export abstract class AbstractProfileValidator extends AbstractionComponent {

    validationFormGroup!: FormGroup;
    profile!: ProfileInfo;
    validation!: Validation;
    validationFieldConfigs: FieldConfig[] = [];
    validationImage?: string;
    fieldKeys: string[] = [];

    protected constructor(protected fb: FormBuilder) {
        super();
    }


    public initialize(init: ProfileValidationConfig): void {
        this.validation = init.profile.validation;
        this.profile = init.profile;
        this.fieldKeys = this.validation.validationFields.map(filed => filed.key);
        this.validationFieldConfigs = this.validationFieldsToFieldConfigs(this.validation.validationFields);
        this.validationFormGroup = init.group;
        this.validationImage = init.validationImage;
    }

    public initializeValidationFormGroup(fieldConfigs: FieldConfig[]): void {
        this.addValidationFieldItems(fieldConfigs);
    }


    get validationFields(): FormArray {
        return this.validationFormGroup?.get("validationFields") as FormArray;
    }

    isImageVisible() {
        return this.validationImage ?? false;
    }


    public addValidationFieldItems(fields: FieldConfig[]):FormGroup {
        let validationFields = this.validationFields;
        if (validationFields && fields && fields.length > 0) {
            fields.forEach(field => {
              if (!validationFields.value.some((fieldValue:any) => field.key === fieldValue.key && field.profileId === fieldValue.profileId))
                validationFields.push(this.createValidationFieldItem(field));
            });
        }
        return (validationFields.controls.find(c => c.value.key === fields[0].key && c.value.profileId === this.profile.profileId) as FormGroup);
    }

    public createValidationFieldItem(field: FieldConfig): FormGroup {
        return this.fb.group({
                key: [field.key],
                value: ['', CustomValidators.getValidators(field.validations)],
                profileId:this.profile.profileId
            }
        );
    }


    private validationFieldsToFieldConfigs(validationFields: ValidationFieldConfig[]): FieldConfig[] {
        let fieldConfigs: FieldConfig[] = [];
        if (validationFields && validationFields.length > 0) {
            fieldConfigs = validationFields.map((field: ValidationFieldConfig) => {
                const fieldConfig: FieldConfig = <any>field;
                fieldConfig.name = 'value';
                fieldConfig.validations = CustomValidators.createValidations(field);
                fieldConfig.profileId = this.profile.profileId;
                return fieldConfig;
            });
        }
        return fieldConfigs;
    }

}
